// Interceptor de carga — expone un signal global de isLoading
import { HttpInterceptorFn } from '@angular/common/http';
import { signal } from '@angular/core';
import { finalize } from 'rxjs/operators';

// Signal global de estado de carga, accesible desde cualquier componente
export const isLoadingSignal = signal<boolean>(false);

// Contador de peticiones activas para manejar múltiples requests simultáneos
let activeRequests = 0;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  activeRequests++;
  isLoadingSignal.set(true);

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
      if (activeRequests === 0) {
        isLoadingSignal.set(false);
      }
    }),
  );
};
